<!-- Grid Card -->
@if (cardType === CardType.Grid) {
  <div
    [ngClass]="questionnaire ? 'flex bg-surface-background' : 'hidden lg:flex bg-periwinkle-soft'"
    [class.opacity-70]="questionnaire?.isArchived"
    class="rounded-[10px] min-h-[390px] border border-textbox-border p-[24px] items-center justify-center"
  >
    @if (questionnaire) {
      <div class="w-full h-full flex flex-col cursor-pointer">
        <div
          class="font-spaceGrotesk text-[12px] mb-[16px] flex items-start justify-between gap-3"
        >
          <div class="flex flex-wrap gap-2">
            <span
              class="rounded-full border border-textbox-border bg-surface-muted px-3 py-1 text-support-text"
            >
              {{ questionnaire.status }}
            </span>
            @if (questionnaire.isArchived) {
              <span
                class="rounded-full border border-kek-purple/30 bg-kek-purple/10 px-3 py-1 text-kek-purple"
              >
                Archived
              </span>
            }
          </div>
          @if (showArchiveAction && !questionnaire.isArchived) {
            <button
              type="button"
              (click)="archiveQuestionnaire($event, questionnaire)"
              class="w-[34px] h-[34px] rounded-full border border-textbox-border text-support-text hover:border-red-secondary hover:bg-red-primary hover:text-red-secondary cursor-pointer flex items-center justify-center transition-colors shrink-0"
              aria-label="Archive questionnaire"
              title="Archive questionnaire"
            >
              <span class="material-symbols-outlined text-[18px]">archive</span>
            </button>
          }
        </div>
        <div
          class="mb-[22px] flex h-[150px] w-full items-center justify-center rounded-[8px] border border-periwinkle-border bg-periwinkle-soft"
          aria-hidden="true"
        >
          <span class="material-symbols-outlined text-[56px] text-periwinkle">
            assignment
          </span>
        </div>
        <div
          class="font-spaceGrotesk text-[22px] font-medium mb-[6px] text-inverted-neutral min-h-[56px]"
        >
          {{ questionnaire.name }}
        </div>
        <div class="mb-[14px] space-y-2">
          <div class="flex flex-wrap gap-2">
            <span
              class="rounded-full border border-textbox-border bg-surface-muted px-3 py-1 inter-400 text-[12px] text-support-text"
            >
              {{ getQuestionCount(questionnaire) }}
              {{
                getQuestionCount(questionnaire) === 1 ? 'question' : 'questions'
              }}
            </span>
            @if (getQuestionSetCount(questionnaire) > 0) {
              <span
                class="rounded-full border border-textbox-border bg-surface-muted px-3 py-1 inter-400 text-[12px] text-support-text"
              >
                {{ getQuestionSetCount(questionnaire) }}
                {{
                  getQuestionSetCount(questionnaire) === 1
                    ? 'question set'
                    : 'question sets'
                }}
              </span>
            }
          </div>
          @if (getVisibleQuestionSetChips(questionnaire).length > 0) {
            <div class="flex flex-wrap gap-2">
              @for (
                questionSetName of getVisibleQuestionSetChips(questionnaire);
                track $index
              ) {
                <span
                  class="max-w-full truncate rounded-full border border-periwinkle-border bg-periwinkle-soft px-3 py-1 inter-400 text-[12px] text-periwinkle"
                >
                  {{ questionSetName }}
                </span>
              }
              @if (getHiddenQuestionSetCount(questionnaire) > 0) {
                <span
                  class="rounded-full border border-textbox-border bg-surface-muted px-3 py-1 inter-400 text-[12px] text-support-text"
                >
                  +{{ getHiddenQuestionSetCount(questionnaire) }} more
                </span>
              }
            </div>
          }
        </div>
        <div class="mb-[14px]">
          <div class="font-montserrat text-support-text text-[11px]">
            Modified on {{ questionnaire.modifiedAt | date: 'dd/MM/yyyy' }}
          </div>
          <div class="font-montserrat text-support-text text-[11px]">
            Created on: {{ questionnaire.createdAt | date: 'dd/MM/yyyy' }}
          </div>
        </div>
        <div class="mt-auto">
          <div
            (click)="buttonClickedEvent.emit(questionnaire)"
            class="w-full h-[44px] bg-transparent border border-nav-btn-border text-nav-btn-text rounded-full hidden lg:flex items-center justify-center cursor-pointer hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text transition-colors"
          >
            <span class="inter-500">{{ buttonText }}</span>
          </div>
        </div>
      </div>
    } @else {
      <div
        class="w-full h-full rounded-[10px] flex flex-col items-center transition pb-4"
      >
        <div class="flex-1 flex items-center justify-center">
          <span class="home-action-icon material-icons-outlined">add</span>
        </div>
        <div
          [routerLink]="['/admin', 'questionnaire']"
          data-testid="create-new-questionnaire"
          class="w-full bg-transparent border border-nav-btn-border text-nav-btn-text rounded-full flex items-center justify-center cursor-pointer py-2 px-4 hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text transition-colors mb-[12px]"
        >
          <span class="inter-500 text-center whitespace-normal break-words">
            Create New<br>Questionnaire
          </span>
        </div>
      </div>
    }
  </div>
}

<!-- Row Card -->
@if (cardType === CardType.Row) {
  <div
    [ngClass]="questionnaire ? 'flex bg-surface-background' : 'hidden lg:flex bg-periwinkle-soft'"
    [class.opacity-70]="questionnaire?.isArchived"
    class="rounded-[10px] h-[110px] border border-textbox-border p-[16px] pb-[24px] justify-between items-center"
  >
    @if (questionnaire) {
      <div
        class="flex flex-col justify-center gap-2 w-full lg:w-auto ml-4 h-full min-w-0"
      >
        <div
          class="font-termina lg:text-[24px] font-medium whitespace-nowrap overflow-hidden overflow-ellipsis max-w-[90%] lg:max-w-[400px] text-support-text"
        >
          {{ questionnaire.name }}
        </div>
        <div class="hidden lg:flex flex-wrap gap-2 max-w-[560px]">
          <span
            class="rounded-full border border-textbox-border bg-surface-muted px-2 py-1 inter-400 text-[11px] text-support-text"
          >
            {{ getQuestionCount(questionnaire) }}
            {{
              getQuestionCount(questionnaire) === 1 ? 'question' : 'questions'
            }}
          </span>
          @for (
            questionSetName of getVisibleQuestionSetChips(questionnaire);
            track $index
          ) {
            <span
              class="max-w-[160px] truncate rounded-full border border-periwinkle-border bg-periwinkle-soft px-2 py-1 inter-400 text-[11px] text-periwinkle"
            >
              {{ questionSetName }}
            </span>
          }
          @if (getHiddenQuestionSetCount(questionnaire) > 0) {
            <span
              class="rounded-full border border-textbox-border bg-surface-muted px-2 py-1 inter-400 text-[11px] text-support-text"
            >
              +{{ getHiddenQuestionSetCount(questionnaire) }} more
            </span>
          }
        </div>
      </div>
      <div class="flex items-center h-full">
        <div class="hidden lg:block font-montserrat text-[12px]">
          <span class="font-light">Status: </span>
          <span class="font-medium italic">{{ questionnaire.status }}</span>
          @if (questionnaire.isArchived) {
            <span
              class="ml-2 rounded-full border border-kek-purple/30 bg-kek-purple/10 px-2 py-1 text-[11px] text-kek-purple not-italic"
            >
              Archived
            </span>
          }
        </div>
        <div
          class="hidden lg:block h-full w-[4px] bg-base-200 bg-opacity-50 rounded-[10px] mx-[18px]"
        ></div>
        <div
          class="hidden lg:flex justify-center items-center flex-col mr-[14px]"
        >
          <div class="font-montserrat text-support-text text-[11px] mb-[4px]">
            Modified on {{ questionnaire.modifiedAt | date: 'dd/MM/yyyy' }}
          </div>
          <div class="font-montserrat text-support-text text-[11px]">
            Created on: {{ questionnaire.createdAt | date: 'dd/MM/yyyy' }}
          </div>
        </div>
        <div
          (click)="buttonClickedEvent.emit(questionnaire)"
          class="w-[220px] mr-[4px] h-[44px] bg-transparent border border-nav-btn-border text-nav-btn-text rounded-full hidden lg:flex items-center justify-center cursor-pointer hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text transition-colors mb-[8px]"
        >
          <span class="inter-500 text-[14px]">{{ buttonText }}</span>
        </div>
        @if (showArchiveAction && !questionnaire.isArchived) {
          <button
            type="button"
            (click)="archiveQuestionnaire($event, questionnaire)"
            class="w-[36px] h-[36px] rounded-full border border-textbox-border text-support-text hover:border-red-secondary hover:bg-red-primary hover:text-red-secondary hidden lg:flex items-center justify-center cursor-pointer transition-colors mb-[8px] shrink-0"
            aria-label="Archive questionnaire"
            title="Archive questionnaire"
          >
            <span class="material-symbols-outlined text-[18px]">archive</span>
          </button>
        }
      </div>
    } @else {
      <div class="flex items-center ml-4">
        <span class="home-action-icon material-icons-outlined">add</span>
      </div>
      <div
        [routerLink]="['/admin', 'questionnaire']"
        data-testid="create-new-questionnaire"
        class="w-auto h-[37px] bg-transparent border border-nav-btn-border text-nav-btn-text rounded-full flex items-center justify-center cursor-pointer px-4 hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text transition-colors"
      >
        <span class="inter-500 text-center whitespace-normal">
          Create New Questionnaire
        </span>
      </div>
    }
  </div>
}
